<div class="tmp-section-item-wrapper">
    <span class="tmp-section-title">{{title}}</span>
    @if(!isCheckBox) {
    <div class="tmp-section-body tmp-flexy">
        <ng-container *ngFor="let item of list">
            <button class="tmp-f-btn" [class.tmp-f-btn-selected]="item.selected" [matTooltip]="item?.description"
                (click)="selectItem(item)" matRipple>{{item.name}}</button>
        </ng-container>
    </div>
    } @else {
    <div class="tour-wrapper">
        @for (item of list | slice:0:slicenbr; track $index) {
        <button class="tour-item-wrapper" (click)="selectItem(item)" [matTooltip]="item?.description" matRipple>
            <mat-icon class="tour-item-icon ">{{item.selected ? (isMultiselect ? 'check_box' : 'radio_button_checked') : (isMultiselect? 'check_box_outline_blank': 'radio_button_unchecked')}}</mat-icon>
            <span class="tour-item-name">{{item.name}}</span>
        </button>
        }
        @if(list?.length > 5) {
        @if(slicenbr < list.length) { <button class="showallbtn" (click)="showMore(list.length)" matRipple>
            <span>alle {{list.length}} anzeigen</span>
            </button>
            } @else {
            <button class="showallbtn" (click)="showMore(5)" matRipple>
                <span>weniger anzeigen</span>
            </button>
            }
            }
    </div>
    }
</div>